import { onRole, type Block, type Link, type Text } from '@ksa/model'
import { SiteLink, SiteText, hasText } from '../context.tsx'

type Props = { heading: Text; subheading: Text; ctaLabel: Text; ctaLink: Link; background: string }

/** The moment the page asks for something. `s-cta-band` is also the hook the print stylesheet uses to
 *  drop it — nobody prints a "Book now" button. */
export function CtaBlock({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const ground = p.background ?? 'brand'
  const boxed = block.variant === 'boxed'
  const style = { background: `var(--${ground})`, color: `var(--${onRole(ground)})` }

  const body = (
    <div className="s-center s-stack">
      <h2 className="s-h2">
        <SiteText value={p.heading} />
      </h2>
      {hasText(p.subheading) && (
        <p className="s-lead s-soft">
          <SiteText value={p.subheading} />
        </p>
      )}
      {hasText(p.ctaLabel) && (
        <div>
          <SiteLink link={p.ctaLink} className="s-btn">
            <SiteText value={p.ctaLabel} />
          </SiteLink>
        </div>
      )}
    </div>
  )

  if (boxed) {
    return (
      <section className="s-section s-cta-band">
        <div className="s-wrap">
          <div style={{ ...style, borderRadius: 'var(--site-radius)', padding: 'clamp(2rem, 5vw, 3.5rem)' }}>
            <div className="s-narrow">{body}</div>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="s-section s-cta-band" style={style}>
      <div className="s-wrap s-narrow">{body}</div>
    </section>
  )
}
